<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :onFetchData="onFetchData"
    :actions="actions"
    :onFormSubmit="handleSubmit"
    :form="form"
    :title="$t('model.setting')"
    resource="settings"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Setting extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'customer_service_email',
        label: this.$t('setting.customerServiceEmail'),
      },
      {
        prop: 'share_cover',
        label: this.$t('setting.shareCover'),
        renderCell: 'storageAttachment',
      },
      {
        prop: 'share_title',
        label: this.$t('setting.shareTitle'),
      },
      {
        prop: 'show_tags',
        label: this.$t('setting.showTags'),
        renderCell: 'bool',
      },
      {
        prop: 'about_flexform_url',
        label: this.$t('setting.aboutFlexformUrl'),
      },
    ];
  }

  async onFetchData() {
    if (this.type === 'edit' || this.type === 'show') {
      const data = await this.$request.get('/settings');
      return {  data }
    }
  }

  async handleSubmit({ data }) {
    try {
      this.formLoading = true;
      let body = data;
      await this.$request.put('/settings', body);
      this.$message.success('更新成功');
      this.$router.push({ name: 'settings.show' });
    } finally {
      this.formLoading = false;
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'customer_service_email',
        label: this.$t('setting.customerServiceEmail'),
        renderCell: {
          component: 'input',
          required: true,
        }
      },
      {
        prop: 'share_cover',
        label: this.$t('setting.shareCover'),
        renderCell: {
          component: 'upload',
          required: true,
          hint: `${this.$t('suggestSize')} 5:4`,
        }
      },
      {
        prop: 'share_title',
        label: this.$t('setting.shareTitle'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'show_tags',
        label: this.$t('setting.showTags'),
        renderCell: {
          component: 'switch',
        }
      },
      {
        prop: 'about_flexform_url',
        label: this.$t('setting.aboutFlexformUrl'),
        renderCell: {
          component: 'input',
          hint: this.$t('hints.mustBeABusinessDomain'),
          required: true,
        }
      },
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions() {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'settings.edit' }
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/settings',
    name: 'settings.show',
    component: Setting,
    props: {
      type: 'show'
    },
    meta: {
      backBtn: false
    }
  },
  {
    path: '/settings/edit',
    name: 'settings.edit',
    component: Setting,
    props: {
      type: 'edit',
    }
  },
]
</script>
